import Api from '@common/services/api';
import { APIEvaluationForm, CategoryPayload } from '../types';

export const createCategory = async (
    organisationId: string,
    payload: CategoryPayload
  ) => {
    const { data } = await Api.post<{ data: APIEvaluationForm }>(
      `/v1/organisations/${organisationId}/performance/competency/categories`,
      payload
    );

    return { data };
  };
